(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("singlePageExpress", [], factory);
	else if(typeof exports === 'object')
		exports["singlePageExpress"] = factory();
	else
		root["singlePageExpress"] = factory();
})(this, () => {
return 